
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AccountId } from '@/types';

@Component
export default class ProfileAccounts extends Vue {
	@Prop({ type: Object, required: true }) properties!: { accounts: AccountId[] };
}
